import type { SectionFooterBase, SectionFooterMediaManager } from '@wix/add-panel-common';
import { ActionSectionItemAction } from '@wix/add-panel-common';
import { symbol as Symbol } from '@wix/santa-editor-symbols';
import { Button } from '@wix/wix-base-ui';
import classnames from 'classnames';
import React, { FC } from 'react';
import { useActionsDispatcher } from '../../../ActionsDispatcher';
import { useCurrentCategory } from '../../../CurrentCategoryProvider';
import { useUtils } from '../../../UtilsProvider';
import styles from './SectionFooter.scss';
import type { SectionFooterProps } from './SectionFooter.types';

const isMediaManagerFooter = (footer: SectionFooterBase): footer is SectionFooterMediaManager =>
  footer.action === ActionSectionItemAction.OpenMediaManager;

export const SectionFooterComponent: FC<SectionFooterProps> = ({ footer, section, className }) => {
  const { styleOverride, label } = footer;
  const currentCategory = useCurrentCategory();
  const { translate } = useUtils();
  const { dispatchOpenMediaManager } = useActionsDispatcher();

  const handleClick = () => {
    if (isMediaManagerFooter(footer)) {
      dispatchOpenMediaManager({
        categoryId: currentCategory.id,
        sectionTitle: section?.translations?.title || '',
        sectionName: section.sectionName,
        mediaManagerOptions: footer.mediaManagerOptions,
      });
    }
  };

  return (
    <div className={classnames(styles.footerWrapper, className)} style={styleOverride}>
      <Button className="btn-confirm-secondary btn-sm" onClick={handleClick} dataHook="section-footer-button">
        {translate(label)}
        <Symbol name="arrowRight" className={styles.arrow} />
      </Button>
    </div>
  );
};
